import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useTitle } from 'src/hooks/useTitle';

import CrmBoard from 'src/components/Crm/CrmBoard/CrmBoard';
import SalesManagement from 'src/components/Crm/SalesManagement';
import IssueHistory from 'src/components/Issue/IssueHistory';
import IssueLiabilityManagement from 'src/components/Issue/IssueLiabilityManagement';
import IssueLogisticsManagement from 'src/components/Issue/IssueLogisticsManagement/IssueLogisticsManagement';
import IssueManage from 'src/components/Issue/IssueManage';
import IssueRegister from 'src/components/Issue/IssueRegister/IssueRegister';
import IssueStoreManagement from 'src/components/Issue/IssueStoreManagement';
import IssueTaskPrint from 'src/components/Issue/IssueTaskPrint';

const IssuePage: FC<{ title: string }> = ({ title }) => {
  useTitle(`GU 관리자 | ${title}`);
  return (
    <Routes>
      <Route path='/board' element={<CrmBoard />} />
      <Route path='/register' element={<IssueRegister />} />
      <Route path='/manage' element={<IssueManage />} />
      <Route path='/history' element={<IssueHistory />} />
      <Route path='/store-management' element={<IssueStoreManagement />} />
      <Route path='/logistics-management' element={<IssueLogisticsManagement />} />
      <Route path='/liability-management' element={<IssueLiabilityManagement />} />
      <Route path='/sales-management' element={<SalesManagement />} />
      <Route path='/print' element={<IssueTaskPrint />} />
      <Route path='*' element={<Navigate to='board' replace />} />
    </Routes>
  );
};

export default IssuePage;
